import { nanoid } from 'nanoid'
import React from 'react'
import modalStore from 'shared/ui/Modal/store/modalStore.ts'
import {
  type IHandoffToHumanContentProps,
  HandoffToHumanContent,
} from './HandoffToHumanContent/HandoffToHumanContent.tsx'

export const handoffToHuman = (props: Omit<IHandoffToHumanContentProps, 'onClose'>) => {
  const id = nanoid()
  modalStore.addModal({
    id,
    title: 'Handoff to human',
    pureContent: true,
    ModalContent: () => (
      <HandoffToHumanContent onClose={() => modalStore.closeModal(id)} {...props} />
    ),
  })
}
